import { User } from '../types';
import api from './api';

// To-do: Define types for login/register credentials
export interface RegisterResponse {
  message: string;
  email: string;
  emailDelivered?: boolean;
}

export interface ConfirmEmailResponse {
  message: string;
  autoLoggedIn?: boolean;
  user?: User;
}

export const login = async (credentials: any): Promise<User> => {
  try {
    const response = await api.post('/auth/login', credentials);
    
    // Check if the response indicates an error
    if (response.status >= 400) {
      throw new Error(`Login failed with status ${response.status}: ${response.data?.message || 'Unknown error'}`);
    }
    
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const register = async (credentials: any): Promise<RegisterResponse> => {
  const response = await api.post('/auth/register', credentials);
  
  // Check if the response indicates an error
  if (response.status >= 400) {
    throw new Error(`Registration failed with status ${response.status}: ${response.data?.message || 'Unknown error'}`);
  }
  
  return response.data;
};

export const resendConfirmation = async (email: string): Promise<{ message: string }> => {
  const response = await api.post('/auth/resend-confirmation', { email });
  return response.data;
};

export const confirmEmail = async (token: string): Promise<ConfirmEmailResponse> => {
  const response = await api.get(`/auth/confirm-email`, {
    params: { token },
  });
  return response.data;
};

export const requestPasswordReset = async (email: string): Promise<{ message: string }> => {
  const response = await api.post('/auth/forgot-password', { email });
  return response.data;
};

export const resetPassword = async (
  token: string,
  password: string
): Promise<{ message: string }> => {
  const response = await api.post('/auth/reset-password', { token, password });
  return response.data;
};

export const logout = async (): Promise<any> => {
  const response = await api.post('/auth/logout');
  return response.data;
};

export const refresh = async (): Promise<User> => {
  const response = await api.post('/auth/refresh');
  return response.data;
};

export const updateLanguage = async (language: string): Promise<User> => {
  const response = await api.patch('/auth/me/language', { language });
  return response.data;
};
